<app-header style="background-color: #FF9A00; height: 60px;" [fixed]="true" [asideMenuToggler]="false"
  [navbarBrandFull]="false" [navbarBrandText]="false" [navbarBrandRouterLink]="false" [mobileAsideMenuToggler]="false"
  [sidebarToggler]="false" [asideMenuToggler]="'lg'">

  <ul class="nav navbar-nav d-md-down-none">
    <a [routerLink]="['/landingpage']">
      <img src="assets/img/login/Logo.png " width="60px" height="60px" alt=""
        style="margin-left: 20px; margin-top: -5px;">
    </a>
    <!-- <a class="navbar-brand px-20"><img src="../../../assets/img/login/Logo.png" width="63px" height="63px" ></a> -->
    <!-- <li>
      <img [src]="brandLogo" width="250" height="80">
    </li> -->

    <!-- <li class="nav-item px-4" *ngFor="let listmenu of list.menu">
        <a class="nav-link" [routerLink]="['/', list.link, listmenu.link]" style="font-size: 14px; color: white;" >{{listmenu.nama}}</a>
      </li>
      <li class="nav-item px-4" >
        <a class="nav-link" [routerLink]="['/bos-negeri/input-bku/daftar-opd']" style="font-size: 14px; color: white;" >Daftar OPD</a>
      </li>
      <li class="nav-item px-4" >
        <a class="nav-link" [routerLink]="['/bos-negeri/input-bku/daftar-bku']" style="font-size: 14px; color: white;" >Daftar BKU</a>
      </li> -->
    <li class="nav-item dropdown dropdown-area" dropdown *ngFor="let list of listAplikasi"
      style="color: #fff; margin-left: 10px; margin-right: 10px;">
      <a dropdownToggle class="nav-link dropdown-toggle" type="button" id="mega-menu" data-toggle="dropdown"
        aria-haspopup="true" aria-expanded="false" style="color: #fff;">
        {{list.nama}}
      </a>

      <div class="dropdown-menu scrollable-menu" aria-labelledby="navbarDropdown" *dropdownMenu
        style="margin-top: 10px;max-height: 70vh !important; overflow-y: scroll !important;">
        <a class="dropdown-item" *ngFor="let listmenu of list.menu" [routerLink]="['/', list.link, listmenu.link]"
          style="max-height: 180px; text-overflow: ellipsis;">{{listmenu.nama}}</a>
      </div>
    </li>



    <!-- <li class="nav-item px-4" >
      <a class="nav-link" [routerLink]="['/']" style="font-size: 14px; color: white;" >OtoritasA</a>
    </li>
    <li class="nav-item dropdown dropdown-area px-4" dropdown>
      <a dropdownToggle class="nav-link dropdown-toggle" style="font-size: 14px; color: white;" type="button" id="mega-menu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        Aplikasi
      </a>
        <div class="dropdown-menu mega-area" aria-label="mega-menu" *dropdownMenu style="left:auto;">
            <div class="row" style=" margin-right: -187px !important;">

              <div class="col-sm-4">
                <a class="dropdown-item" href="#">Otoritas Pengguna</a>
                <a class="dropdown-item" href="#">Otoritas Menu</a>
                <a class="dropdown-item" href="#">Otoritas Aplikasi</a>
              </div>
            </div>

            <br>

        </div>
    </li>
    <li class="nav-item px-4" >
      <a class="nav-link" [routerLink]="['/user-management/pengguna']" style="font-size: 14px; color: white;" >Pengguna</a>
    </li>
    <li class="nav-item px-4" >
      <a class="nav-link" [routerLink]="['/user-management/menu']" style="font-size: 14px; color: white;" >Menu</a>
    </li>
    <li class="nav-item px-4" >
      <a class="nav-link" [routerLink]="['/user-management/pengguna']" style="font-size: 14px; color: white;" >Aplikasi</a>
    </li> -->
    <!-- <li class="nav-item px-4" >
      <a class="nav-link" [routerLink]="['/']"style="font-size: 14px; color: white;"  >Profil Sekolah</a>
    </li>
    <li class="nav-item px-4" >
      <a class="nav-link" [routerLink]="['/dashboard']"style="font-size: 14px; color: white;"  >Profil Sekolah</a>
    </li> -->
  </ul>
  <!-- ul tambahan untuk sementara -->
  <ul class="nav navbar-nav d-md-down-none">
    <!-- List items for listSekolah -->
    <ng-container
      *ngIf="!(currentUser.authorities.includes('ADMIN-DINAS') || currentUser.authorities.includes('SUDIN'))">
      <ng-container *ngFor="let listSek of listSekolah">
        <li class="nav-item dropdown dropdown-area" dropdown
          style="color: #fff; margin-left: 10px; margin-right: 10px;">
          <a dropdownToggle class="nav-link dropdown-toggle" type="button" id="mega-menu2" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            {{tahunAnggaran}} | {{listSek.nama}} | {{listSek.nrk }}
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown" *dropdownMenu>
            <a class="dropdown-item" (click)="click()">Logout </a>
          </div>
        </li>
      </ng-container>
    </ng-container>


    <!-- List items for listPengguna -->
    <ng-container *ngIf="currentUser.authorities.includes('ADMIN-DINAS') || currentUser.authorities.includes('SUDIN')">
      <li class="nav-item dropdown dropdown-area" dropdown style="color: #fff; margin-left: 10px; margin-right: 10px;">
        <a dropdownToggle class="nav-link dropdown-toggle" type="button" id="mega-menu2" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">
          {{tahunAnggaran}} | {{listPengguna.nama}} | {{listPengguna.nrk }}
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown" *dropdownMenu>
          <a class="dropdown-item" (click)="click()">Logout </a>
        </div>
      </li>
    </ng-container>
  </ul>





  <!-- Data untuk dummy -->
  <!-- <ul class="nav navbar-nav d-md-down-none">
    <li class="nav-item px-4" >
      <a class="nav-link" [routerLink]="['/bos-negeri/input-bku/daftar-opd']" style="font-size: 14px; color: white;" >Daftar OPD</a>
    </li>
    <li class="nav-item px-4" >
      <a class="nav-link" [routerLink]="['/bos-negeri/input-bku/daftar-bku']" style="font-size: 14px; color: white;" >Daftar BKU</a>
    </li>
  </ul> -->


</app-header>
<div class="app-body" style="padding-top: 20px; background-color: #efefef;">
  <main class="main">

    <div class="container-fluid">
      <div class="page-header">
        <div class="row">
          <div class="col-12">
            <ol class="breadcrumb bg-transparent pr-0 pl-0">
              <h5 class="mr-3"><strong>{{title}}</strong></h5>
              <li class="breadcrumb-item">
                <a routerLink="/landingpage">
                  <i class="fa fa-home" aria-hidden="true"></i>
                </a>
              </li>
              <li class="breadcrumb-item" *ngIf="breadcrumbs?.parentBreadcrumb">
                <a routerLink="{{breadcrumbs?.parentPath}}">
                  {{breadcrumbs?.parentBreadcrumb}}
                </a>
              </li>
              <li class="breadcrumb-item active" *ngIf="breadcrumbs?.childBreadcrumb">
                {{breadcrumbs?.childBreadcrumb}}
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
<app-footer style="color: grey; font-size: 12px; position: sticky; bottom: 0; z-index: 10;">
  <span>PUSAT DATA DAN INFORMASI KEUANGAN {{tahunAnggaran}}</span>
  <span class="ml-auto">Powered by SIAP BOSP BOP</span>
</app-footer>
